import React, { useState } from "react";

const CreateUserPopup = ({ open, refreshList, link }) => {
  const [error, setError] = useState(null);

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    dataAccessDays: "",
    companyAccess: "",
  });

  const handleChange = (e) => {
    setError("");
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${link}/user/register`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const respData = await response.json();

      if (response.ok) {
        refreshList();
        open(false);
      } else {
        alert(respData.message);
      }
    } catch (error) {
      alert("server error");
    }
  };

  return (
    <div>
      <div className="popup-form">
        <div className="popup-form-main">
          <div className="popup-form-heading">Create New User</div>
          <form onSubmit={handleSubmit}>
            <label>Name :</label>
            <input required onChange={handleChange} type="text" name="name" />

            <label>Email :</label>
            <input required onChange={handleChange} type="email" name="email" />

            <label>Password :</label>
            <input
              required
              onChange={handleChange}
              type="text"
              name="password"
            />

            <label>Days Access :</label>
            <input
              required
              onChange={handleChange}
              min={0}
              type="number"
              name="dataAccessDays"
            />

            <label>Business Access :</label>
            <select required onChange={handleChange} name="companyAccess">
              <option value="" disabled selected>
                {" "}
                ----- select option ------{" "}
              </option>
              <option value="Garage On Call">Garage On Call</option>
              <option value="Fluffy Touch">Fluffy Touch</option>
              <option value="Glazma">Glazma</option>
              <option value="Repair Buddy">Repair Buddy</option>
            </select>

            {error ? <div className="popup-form-error">{error}</div> : ""}

            <div className="popup-form-buttons">
              <div onClick={() => open(false)}>Cancel</div>
              <button>Create</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateUserPopup;
